import { SECTION_NAMES, TOURNAMENTS_API_URLS } from '@repo/common';
import { TOURNAMENTS_CAMPAIGN_TYPE } from 'features/campaigns';
import type { ICampaignConfig } from '../campaignConfig.types';

export const tournamentsConfig: ICampaignConfig = {
    type: TOURNAMENTS_CAMPAIGN_TYPE,
    displayName: 'Tournaments',
    sectionName: SECTION_NAMES.TOURNAMENTS,
    hostSettingsKey: 'tournamentHost',
    mainFetch: {
        urlTemplate: `\${host}${TOURNAMENTS_API_URLS.PREFIX}${TOURNAMENTS_API_URLS.GET_TOURNAMENT}`,
        timing: {
            staleTime: 5 * 60 * 1000,       // 5 minutes
            refetchInterval: 60 * 1000,      // 1 minute
            refetchOnWindowFocus: true,
        },
        retry: {
            maxRetries: 2,
            retryDelayBase: 1000,
            maxRetryDelay: 30000,
        },
        queryKeySegments: ['tournaments', 'list'],
    },
    subFetches: {
        leaderboard: {
            name: 'leaderboard',
            urlTemplate: `\${host}${TOURNAMENTS_API_URLS.PREFIX}\${campaignId}${TOURNAMENTS_API_URLS.GET_LEADERBOARD}`,
            timing: {
                staleTime: 30 * 1000,
                refetchInterval: 5 * 1000,
                refetchIntervalInBackground: false,
            },
            retry: {
                maxRetries: 3,
                retryDelayBase: 1000,
                maxRetryDelay: 10000,
            },
            queryKeySegments: ['tournaments', 'leaderboard'],
        },
        join: {
            name: 'join',
            urlTemplate: `\${host}${TOURNAMENTS_API_URLS.PREFIX}${TOURNAMENTS_API_URLS.JOIN_TOURNAMENT}`,
            method: 'POST',
            timing: {
                staleTime: 0,
                refetchInterval: false,
                refetchOnWindowFocus: false,
            },
            retry: {
                maxRetries: 1,
                retryDelayBase: 1000,
                maxRetryDelay: 5000,
            },
            queryKeySegments: ['tournaments', 'join'],
            buildJoinInRequestData: ({ sessionInfo, url, data }) => {
                const fullUrl = url;
                const body = {
                    sessionKey: sessionInfo.sessionKey,
                    playerId: sessionInfo.playerId,
                    tournamentIds: data,
                };

                return {
                    fullUrl,
                    requestBody: body
                }
            }
        },
    },
    mutations: {},
};
